import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]

  addAssignment() {
    if (!this.hasTemplateTarget || !this.hasListTarget) return

    const index = this.listTarget.querySelectorAll("[data-assignment-row]").length
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, String(index))
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  removeAssignment(event) {
    const row = event.target.closest("[data-assignment-row]")
    if (row) row.remove()
  }
}
